export default __webpack_public_path__ + "static/media/1071.8b0954f2.png";